/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnecthint12Inputs */

const en_crosspostingconnecthint12 = /** @type {(inputs: Crosspostingconnecthint12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll be taken to a secure page of our connection service to sign in with the platform.`)
};

const de_crosspostingconnecthint12 = /** @type {(inputs: Crosspostingconnecthint12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wirst auf eine sichere Seite unseres Verbindungsdienstes weitergeleitet, um dich bei der Plattform anzumelden.`)
};

/**
* | output |
* | --- |
* | "You'll be taken to a secure page of our connection service to sign in with the platform." |
*
* @param {Crosspostingconnecthint12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnecthint12 = /** @type {((inputs?: Crosspostingconnecthint12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnecthint12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnecthint12(inputs)
	return de_crosspostingconnecthint12(inputs)
});
export { crosspostingconnecthint12 as "crosspostingConnectHint1" }